import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex
  flex-col
  w-full
`);
